/* Aurah Living — wishlist (localStorage-backed) */
(function () {
  var KEY = 'aurah_wishlist_v1';

  function getList() {
    try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; }
  }
  function setList(list) {
    localStorage.setItem(KEY, JSON.stringify(list));
  }
  function isSaved(id) {
    return getList().some(function (i) { return String(i.id) === String(id); });
  }
  function toggle(item) {
    var list = getList();
    var idx = list.findIndex(function (x) { return String(x.id) === String(item.id); });
    if (idx >= 0) list.splice(idx, 1);
    else list.unshift(item);
    setList(list);
    syncUI();
  }
  function remove(id) {
    var list = getList().filter(function (x) { return String(x.id) !== String(id); });
    setList(list);
    syncUI();
  }

  function syncUI() {
    var list = getList();
    var count = list.length;
    var badges = document.querySelectorAll('[data-wishlist-count]');
    badges.forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? 'inline-flex' : 'none';
    });
    var btns = document.querySelectorAll('[data-wish-toggle]');
    btns.forEach(function (b) {
      var id = b.getAttribute('data-product-id');
      if (isSaved(id)) {
        b.classList.add('is-saved');
        b.setAttribute('aria-pressed', 'true');
      } else {
        b.classList.remove('is-saved');
        b.setAttribute('aria-pressed', 'false');
      }
    });
    renderGrid();
  }

  function escapeHtml(s) {
    if (s == null) return '';
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#39;' }[c];
    });
  }

  function renderGrid() {
    var mount = document.querySelector('[data-wishlist-grid]');
    if (!mount) return;
    var list = getList();
    if (list.length === 0) {
      mount.innerHTML = '<p class="aurah-wishlist__empty">Your wishlist is empty. Tap the heart on any piece to save it here.</p>';
      return;
    }
    mount.innerHTML = list.map(function (i) {
      var title = escapeHtml(i.title);
      var price = escapeHtml(i.price);
      var image = escapeHtml(i.image);
      var handle = escapeHtml(i.handle);
      var id = escapeHtml(i.id);
      return (
        '<article class="aurah-wishlist__card">' +
          '<a class="aurah-wishlist__card-link" href="/products/' + handle + '">' +
            '<div class="aurah-wishlist__card-media">' +
              (image ? '<img src="' + image + '" alt="' + title + '" loading="lazy">' : '') +
            '</div>' +
            '<div class="aurah-wishlist__card-body">' +
              '<h3 class="aurah-wishlist__card-title">' + title + '</h3>' +
              '<p class="aurah-wishlist__card-price">' + price + '</p>' +
            '</div>' +
          '</a>' +
          '<button type="button" class="aurah-wishlist__card-remove" data-wishlist-remove data-product-id="' + id + '" aria-label="Remove from wishlist">' +
            '<svg width="14" height="14" viewBox="0 0 14 14" aria-hidden="true"><path d="M1 1l12 12M13 1L1 13" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>' +
          '</button>' +
        '</article>'
      );
    }).join('');
  }

  document.addEventListener('click', function (e) {
    var toggleBtn = e.target.closest && e.target.closest('[data-wish-toggle]');
    if (toggleBtn) {
      e.preventDefault();
      toggle({
        id: toggleBtn.getAttribute('data-product-id'),
        handle: toggleBtn.getAttribute('data-product-handle'),
        title: toggleBtn.getAttribute('data-product-title'),
        image: toggleBtn.getAttribute('data-product-image'),
        price: toggleBtn.getAttribute('data-product-price')
      });
      return;
    }
    var removeBtn = e.target.closest && e.target.closest('[data-wishlist-remove]');
    if (removeBtn) {
      e.preventDefault();
      remove(removeBtn.getAttribute('data-product-id'));
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncUI);
  } else {
    syncUI();
  }

  // Sync across tabs
  window.addEventListener('storage', function (e) {
    if (e.key === KEY) syncUI();
  });
})();
